import { render, staticRenderFns } from "./StepFour.vue?vue&type=template&id=3fee81c2&scoped=true"
import script from "./StepFour.vue?vue&type=script&lang=js"
export * from "./StepFour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fee81c2",
  null
  
)

export default component.exports